/* NUVO Recently Viewed Products v14c */
(function() {
  var STORAGE_KEY = 'nuvo_recently_viewed';
  var MAX_ITEMS = 8;
  var SEARCH_SHOW = 4;

  function getLang() {
    var path = window.location.pathname;
    if (path.startsWith('/ru')) return 'ru';
    if (path.startsWith('/en')) return 'en';
    return 'ka';
  }

  function getLangPrefix() {
    var lang = getLang();
    return lang === 'ka' ? '' : '/' + lang;
  }

  function getHeadingText() {
    var lang = getLang();
    if (lang === 'ru') return '\u041D\u0435\u0434\u0430\u0432\u043D\u043E \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0435';
    if (lang === 'en') return 'Recently Viewed';
    return '\u10D1\u10DD\u10DA\u10DD\u10E1 \u10DC\u10D0\u10DC\u10D0\u10EE\u10D8';
  }

  function getMonthlyLabel() {
    var lang = getLang();
    if (lang === 'ru') return '\u043C\u0435\u0441.';
    if (lang === 'en') return 'mo.';
    return '\u10D7\u10D5\u10D4\u10E8\u10D8';
  }

  function extractHandle(urlPath) {
    if (!urlPath) return null;
    var m = urlPath.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function cleanItems(items) {
    var seen = {};
    var result = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item.handle && item.url) item.handle = extractHandle(item.url);
      if (!item.handle || item.handle === 'undefined') continue;
      if (seen[item.handle]) continue;
      seen[item.handle] = true;
      result.push(item);
    }
    return result;
  }

  function saveCurrentProduct() {
    if (!window.location.pathname.includes('/products/')) return;
    var handle = extractHandle(window.location.pathname);
    if (!handle) return;
    var titleEl = document.querySelector('.product__title, h1.h2');
    var imgEl = document.querySelector('.product__media img, .product__media-item img');
    var priceEl = document.querySelector('.price-item--regular, .price__regular .price-item');
    if (!titleEl) return;
    var imgSrc = '';
    if (imgEl) {
      imgSrc = imgEl.src || imgEl.getAttribute('data-src') || '';
      imgSrc = imgSrc.replace(/width=\d+/g, 'width=400');
    }
    var monthlyAmount = (typeof window.nuvoMonthlyPrice === 'string' && window.nuvoMonthlyPrice !== '') ? window.nuvoMonthlyPrice : '';
    var product = {
      handle: handle,
      title: titleEl.textContent.trim().substring(0, 80),
      image: imgSrc,
      price: priceEl ? priceEl.textContent.trim().split('/')[0].trim() : '',
      monthly: monthlyAmount,
      timestamp: Date.now()
    };
    try {
      var items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      items = cleanItems(items);
      items = items.filter(function(it) { return it.handle !== product.handle; });
      items.unshift(product);
      if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch(e) {}
  }

  function getRecentlyViewed() {
    try {
      var items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      items = cleanItems(items);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      var currentHandle = extractHandle(window.location.pathname);
      return items.filter(function(it) { return it.handle !== currentHandle; });
    } catch(e) { return []; }
  }

  function fetchTranslatedProduct(handle) {
    if (!handle) return Promise.resolve(null);
    var prefix = getLangPrefix();
    return fetch(prefix + '/products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .catch(function() { return null; });
  }

  function formatPrice(cents) {
    return (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function initSearchOverlay() {
    function attach() {
      var found = false;
      document.querySelectorAll('predictive-search').forEach(function(ps) {
        var input = ps.querySelector('input[type="search"]');
        if (!input) return;
        if (input._nuvoRV) return;
        input._nuvoRV = true;
        found = true;
        var resultsDiv = ps.querySelector('[data-predictive-search]');
        if (!resultsDiv) return;
        input.addEventListener('focus', function() {
          if (input.value.trim().length === 0) showRV(ps, resultsDiv);
        });
        input.addEventListener('input', function() {
          var existing = ps.querySelector('#nuvo-search-rv-container');
          if (input.value.trim().length > 0) { if (existing) existing.remove(); }
          else showRV(ps, resultsDiv);
        });
        if (document.activeElement === input && input.value.trim().length === 0) {
          showRV(ps, resultsDiv);
        }
      });
      return found;
    }
    if (!attach()) setTimeout(attach, 300);
    var mo = new MutationObserver(function() { attach(); });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    setTimeout(function() { mo.disconnect(); }, 10000);
  }

  function showRV(ps, resultsDiv) {
    var items = getRecentlyViewed();
    if (items.length === 0) return;
    var old = ps.querySelector('#nuvo-search-rv-container');
    if (old) old.remove();
    var show = items.slice(0, SEARCH_SHOW);
    var prefix = getLangPrefix();
    var ml = getMonthlyLabel();

    var container = document.createElement('div');
    container.id = 'nuvo-search-rv-container';
    container.style.cssText = 'padding:20px 24px;background:#fff;border:1px solid #e0e0e0;border-top:none;';
    var heading = document.createElement('p');
    heading.style.cssText = 'font-size:14px;text-transform:uppercase;letter-spacing:1px;color:#666;margin:0 0 16px;font-weight:600;';
    heading.textContent = getHeadingText();
    container.appendChild(heading);

    var fetches = show.map(function(it) { return fetchTranslatedProduct(it.handle); });
    Promise.all(fetches).then(function(results) {
      results.forEach(function(product, i) {
        var item = show[i];
        if (!item.handle) return;
        var title = product ? product.title : item.title;
        var priceCents = product ? product.price : null;
        var priceText = priceCents !== null ? formatPrice(priceCents) + '\u20BE' : item.price;
        var monthlyVal = item.monthly || '';
        var image = product && product.images && product.images[0] ? product.images[0] : item.image;
        var url = prefix + '/products/' + item.handle;

        var link = document.createElement('a');
        link.href = url;
        link.style.cssText = 'display:flex;align-items:center;gap:14px;padding:10px 0;text-decoration:none;color:inherit;' + (i < show.length - 1 ? 'border-bottom:1px solid #f0f0f0;' : '');
        if (image) {
          var img = document.createElement('img');
          img.src = typeof image === 'string' ? image : '';
          img.alt = '';
          img.style.cssText = 'width:60px;height:60px;object-fit:cover;border-radius:6px;flex-shrink:0;background:#f5f5f5;';
          link.appendChild(img);
        }
        var info = document.createElement('div');
        info.style.cssText = 'flex:1;min-width:0;';
        var t = document.createElement('p');
        t.style.cssText = 'margin:0;font-size:16px;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';
        t.textContent = title;
        info.appendChild(t);
        var priceP = document.createElement('p');
        priceP.style.cssText = 'margin:4px 0 0;font-size:1em;font-weight:600;color:#333;';
        // Compare-at price (strikethrough)
        var compareAtCents = product ? product.compare_at_price : null;
        if (compareAtCents && priceCents && compareAtCents > priceCents) {
          var sEl = document.createElement('s');
          sEl.style.cssText = 'color:#999;text-decoration:line-through;margin-right:6px;font-weight:400;font-size:0.9em;';
          sEl.textContent = formatPrice(compareAtCents) + '\u20BE';
          priceP.appendChild(sEl);
          var saleSpan = document.createElement('span');
          saleSpan.style.cssText = 'color:#c00;font-weight:400;';
          saleSpan.textContent = priceText;
          priceP.appendChild(saleSpan);
        } else {
          priceP.textContent = priceText;
        }
        if (monthlyVal && monthlyVal !== '0' && window.nuvoCreditEnabled) {
          var mSpan = document.createElement('span');
          mSpan.className = 'nuvo-card-monthly';
          mSpan.textContent = ' / ' + ml + ' ' + monthlyVal + '\u20BE';
          priceP.appendChild(mSpan);
        }
        info.appendChild(priceP);
        link.appendChild(info);
        container.appendChild(link);
      });
    });

    resultsDiv.innerHTML = '';
    resultsDiv.appendChild(container);
    ps.setAttribute('open', '');
    ps.classList.add('predictive-search--open');
    resultsDiv.style.display = 'block';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { saveCurrentProduct(); initSearchOverlay(); });
  } else {
    saveCurrentProduct(); initSearchOverlay();
  }
  window.NuvoRecentlyViewed = {
    getRecentlyViewed: getRecentlyViewed,
    fetchTranslatedProduct: fetchTranslatedProduct,
    getLangPrefix: getLangPrefix,
    getMonthlyLabel: getMonthlyLabel,
    formatPrice: formatPrice
  };
})();
